// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2ProcessingBenefitModel {
    static getAttributeTypeMap() {
        return EnrollmentV2ProcessingBenefitModel.attributeTypeMap;
    }
}
EnrollmentV2ProcessingBenefitModel.discriminator = undefined;
EnrollmentV2ProcessingBenefitModel.additionalProperties = false;
EnrollmentV2ProcessingBenefitModel.attributeTypeMap = [
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "claimEligibilityDate",
        "baseName": "claimEligibilityDate",
        "type": "Date"
    },
    {
        "name": "maxBenefit",
        "baseName": "maxBenefit",
        "type": "number"
    },
    {
        "name": "hasUntrackedAccumulator",
        "baseName": "hasUntrackedAccumulator",
        "type": "boolean"
    },
    {
        "name": "queuedProcessingDate",
        "baseName": "queuedProcessingDate",
        "type": "Date"
    },
    {
        "name": "queuedProcessingReason",
        "baseName": "queuedProcessingReason",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentV2ProcessingBenefitModel.js.map